import styled from 'styled-components';
import Button from '../../components/Button';

export const Root = styled.div`
	padding: 40px 0;

	@media (max-width: 768px) {
		padding: 0;
	}
`;

export const HeadContainer = styled.div`
	position: relative;
	height: 394px;

	@media (max-width: 768px) {
		height: auto;
		min-height: 240px;
		margin: 0 -15px;
	}
`;

export const ImportantKnowledge = styled.div`
	width: 100%;
	max-width: 582px;
	max-height: 315px;
	position: fixed;
	top: 50%;
	left: 50%;
	z-index: 1200;
	display: flex;
	flex-direction: column;
	color: #fff;
	transform: translate3d(-50%, -50%, 0);
`;

export const ImportantKnowledgeContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #cc3b1f;
	padding: 50px 30px 20px;
`;

export const ImportantKnowledgeBottom = styled.div`
	display: flex;
	width: 100%;
	height: 51px;
	margin-top: -1px;
`;

export const ImportantKnowledgeBottomLeft = styled.div`
	flex: 1 1 100%;
	width: 100%;
	height: 100%;
	background-color: #cc3b1f;
`;

export const ImportantKnowledgeBottomRight = styled.div`
	flex-shrink: 0;
	width: 50px;
	height: 50px;
	border: 25px solid #da4c30;
	border-right-color: transparent;
	border-bottom-color: transparent;
	box-sizing: border-box;
`;

export const ImportantKnowledgeTitle = styled.div`
	font-size: 36px;
	font-weight: bold;
	margin-bottom: 35px;
`;

export const ImportantKnowledgeText = styled.div`
	font-size: 18px;
	font-weight: bold;
	text-align: center;
	margin-bottom: 45px;
`;

export const HideButton = styled(Button)`
	border-color: #fff;
`;

export const DeveloperHead = styled.header`
	display: grid;
	grid-template-columns: 92px 1fr 180px;
	grid-template-rows: auto 16px 1fr auto auto;
	grid-template-areas: 'breadcrumbs breadcrumbs breadcrumbs' '. . .' '. title rating' '. desc desc' '. address address';
	grid-gap: 12px;
	align-items: start;
	padding: 24px;
	position: relative;
	height: 100%;
	box-sizing: border-box;

	@media (max-width: 768px) {
		padding: 15px;
		grid-template-columns: 1fr;
		grid-template-rows: auto 16px 1fr auto auto auto;
		grid-template-areas: 'breadcrumbs' '.' 'title' 'desc' 'address' 'rating';
	}
`;

export const BreadcrumbsWrapper = styled.div`
	grid-area: breadcrumbs;
`;

export const DeveloperHeaderImage = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	border-radius: 4px;
	background-image: linear-gradient(
			180deg,
			rgba(0, 0, 0, 0) -96.95%,
			rgba(0, 0, 0, 0.0086472) -78.56%,
			rgba(0, 0, 0, 0.03551) -60.17%,
			rgba(0, 0, 0, 0.0816599) -41.78%,
			rgba(0, 0, 0, 0.147411) -23.38%,
			rgba(0, 0, 0, 0.231775) -4.99%,
			rgba(0, 0, 0, 0.331884) 13.4%,
			rgba(0, 0, 0, 0.442691) 31.79%,
			rgba(0, 0, 0, 0.557309) 50.19%,
			rgba(0, 0, 0, 0.668116) 68.58%,
			rgba(0, 0, 0, 0.768225) 86.97%,
			rgba(0, 0, 0, 0.852589) 105.36%,
			rgba(0, 0, 0, 0.91834) 123.76%,
			rgba(0, 0, 0, 0.96449) 142.15%,
			rgba(0, 0, 0, 0.991353) 160.54%,
			#000000 178.93%
		),
		${({ image }) => `url('${image}')`};
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;

	@media (max-width: 768px) {
		border-radius: 0;
	}
`;

export const HeadLeft = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
	margin: 40px 0 0 92px;
`;

export const HeadRight = styled.div`
	display: flex;
	align-self: flex-end;
	flex-wrap: wrap;
`;

export const Title = styled.h1`
	grid-area: title;
	margin: 0;
	${({ theme }) => theme.typography.headlineXXL}
	color: #fff;
`;

export const ShortDescription = styled.div`
	grid-area: desc;
	margin-left: 92px;
	${({ theme }) => theme.typography.textL}
	color: #fff;
`;

export const InfoTitle = styled.div`
	${({ theme }) => theme.typography.headlineXS}
	flex: 1 1 auto;
`;

export const Info = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	background: #f0f1f4;
	border-radius: 4px;
	margin: 32px 0;
	padding: 32px 24px;
	width: 100%;
	max-width: 1000px;
	box-sizing: border-box;

	@media (max-width: 1200px) {
		max-width: 100%;
	}

	@media (max-width: 768px) {
		justify-content: flex-start;
	}
`;

export const InfoItemContainer = styled.div`
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;

	@media (max-width: 480px) {
		flex-direction: column;
		justify-content: flex-start;
	}
`;

export const InfoItem = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	margin: 16px 24px 0 0;

	@media (max-width: 480px) {
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		flex-wrap: nowrap;
		margin-right: 0;
	}
`;

export const InfoItemTitle = styled.div`
	margin-bottom: 4px;
	color: ${({ theme }) => theme.darkGrayColor};
	${({ theme }) => theme.typography.textS};

	@media (max-width: 480px) {
		margin-bottom: 0;
	}
`;

export const InfoItemValue = styled.div`
	${({ theme }) => theme.typography.textBoldM};
`;

export const DevLink = styled(Button)`
	color: #676666;
	font-size: 14px;
	display: inline-block;
	margin-top: 10px;
	transition: opacity 0.3s;
	cursor: pointer;
	text-decoration: underline;
	border: none;
	box-shadow: none;
	padding: 0;
	background-color: transparent;

	&:hover,
	&:active {
		color: #676666;
	}
`;

export const Main = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 1000px;

	@media (max-width: 1200px) {
		max-width: 100%;
	}

	@media (max-width: 768px) {
		flex-wrap: wrap;
	}
`;

export const MainText = styled.article`
	margin: 12px 0 60px;
	white-space: pre-wrap;
	${({ theme }) => theme.typography.textM};
`;

export const MainSide = styled.aside`
	color: #fff;
`;

export const Address = styled.div`
	grid-area: address;
	color: #fff;
	display: flex;
	align-items: center;
	${({ theme }) => theme.typography.textMediumM};
`;

export const AddressIcon = styled.svg`
	flex-shrink: 0;
	width: 16px;
	height: 16px;
	margin-right: 10px;
	fill: #fff;
`;

export const AddressText = styled.div`
	margin-right: 10px;
`;

export const MapWrapper = styled.div`
	position: relative;
	z-index: 1;
	height: 482px;
	border-radius: 4px;
	margin: 24px 0;
`;

export const ObjectTitle = styled.div`
	${({ theme }) => theme.typography.headlineXL};

	@media (max-width: 768px) {
		${({ theme }) => theme.typography.headlineXXLmobile};
	}
`;

export const CardsWrapper = styled.section`
	display: flex;
	flex-direction: column;
	@media (max-width: 768px) {
		flex-wrap: wrap;
	}
`;

export const CardsSide = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;
	margin: 26px 0 18px;
`;

export const CitySelect = styled.div`
	position: relative;
	z-index: 10;
	display: flex;
	margin: 6px 0;
	align-items: center;
	${({ theme }) => theme.typography.textL};
`;

export const Complexes = styled.div`
	width: 100%;
`;

export const RatingTitle = styled.div`
	${({ theme }) => theme.typography.textMediumS};
	${({ footer }) => (footer ? `color: #fff;` : `margin-left: 12px;`)};
	margin-top: 4px;

	@media (max-width: 768px) {
		margin-left: 12px;
	}
`;

export const RatingContainer = styled.div`
	grid-area: rating;
	display: flex;
	${({ theme }) => theme.typography.textMediumS};

	@media (min-width: 769px) {
		flex-wrap: wrap;
	}
`;

export const RatingContainerBottom = styled.div`
	display: flex;
	margin: 6px 0;
	${({ theme }) => theme.typography.textMediumS};
	align-items: center;

	@media (min-width: 769px) {
		max-width: 270px;
	}
`;

export const PaginationWrapper = styled.div`
	display: flex;
	justify-content: center;
	padding: 20px 0 60px;
	text-align: center;

	@media (max-width: 375px) {
		padding: 10px 0 20px;
	}
`;
